import { render, staticRenderFns } from "./RiderAssignmentView.vue?vue&type=template&id=8f38196a&scoped=true&"
import script from "./RiderAssignmentView.vue?vue&type=script&lang=js&"
export * from "./RiderAssignmentView.vue?vue&type=script&lang=js&"
import style0 from "./RiderAssignmentView.vue?vue&type=style&index=0&id=8f38196a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f38196a",
  null
  
)

export default component.exports